<template>
  <ls-table-layout>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleSave" type="primary" >保存</a-button>
      <a-button @click="handleExport" >取消</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.SUPPLY_INFO_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="netSubInventory" slot-scope="{ record }">
            <a-switch :disabled="false" :checked="record.netSubInventory === 'Y'" @change="statusOnChange(record)" />
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { scpSupplyList, listUpdateNetSubInventory } from '@/api/scp/shipmentForecast/supplyInfoList'
  import { generateLsTableResData } from '@/utils/util.js';
  export default {
    name: 'SupplyInfoList',
    components: {
    },
    data () {
      return {
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(scpSupplyList, true),
          pageCurrent: true
        },
        // 查询参数
        queryParams: {
          uomClassList: undefined
        },
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columns: [
          {
            title: '库存组织代码',
            dataIndex: 'inventoryOrganizationCode',
            align: 'center',
            width: 120
          },
          {
            title: '组织名称',
            dataIndex: 'inventoryOrganizationName',
            ellipsis: true,
            width: 120,
            align: 'center'
          },
          {
            title: '子库存代码',
            dataIndex: 'subInventoryCode',
            width: 120,
            align: 'center'
          },
          {
            title: '子库存名称',
            width: 120,
            dataIndex: 'subInventoryName',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '净值仓',
            width: 120,
            dataIndex: 'netSubInventory',
            scopedSlots: { customRender: 'netSubInventory' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '最后更新人',
            width: 120,
            dataIndex: 'updateName',
            align: 'center'
          },
          {
            title: '最后更新日期',
            width: 120,
            dataIndex: 'updateTime',
            ellipsis: true,
            align: 'center'
          }
        ]
      }
    },
    created () {
    },
    mounted () {
      this.onSearch()
    },
    methods: {
    // 表单搜索
        onSearch () {
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
        },
      // 编辑-保存
      handleSave () {
        // if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        //   this.$message.warning('折换不能为空且需大于0')
        //   return
        // }

       const tableData = this.$refs.dataTable.myDataSource;
        listUpdateNetSubInventory(tableData).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      // 取消
      handleCancel (record) {
      },
      statusOnChange (record) {
        record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
      }

    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
  </style>
